const MAX_ROWS = 10;

export function calcRows(maxLength?: number, maxLengthInRow = 30, maxRows = MAX_ROWS): number {
  if (!maxLength || maxLength <= 0) {
    return MAX_ROWS;
  }

  return Math.min(Math.ceil(maxLength / maxLengthInRow), maxRows) + 1;
}
